// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"121":"5ae3c1b2","124":"5e3ab5ca","709":"1241eaaf","730":"e0f72931","822":"c0598b53"}[chunkId] + ".chunk.js";
};